var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid",attrs:{"id":"requireresLoginPage"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin":"1em","color":"#000","text-align":"left"}},[_vm._v(" This application must be launched from within Canvas. ")])])])])
}]

export { render, staticRenderFns }